// pages main
import Home from "@/views/Home";
//import Air from "@/views/air/Air";
import Info from "@/views/info/Info";
import Plant from "@/views/plant/Plant";
import TiranaEYC from "@/views/tiranaeyc/TiranaEYC";
import Raport from "@/views/raport/Raport";
import Trafic from "@/views/trafic/Trafic";

import Turisem from "@/views/turisem/Turisem";
import Setting from "@/views/setting/Setting";
import PayParking from "@/views/pay/PayParking";
import Transport from "@/views/transport/Transport";
import Playground from "@/views/playground/Playground";
import TermsAndConditions from "@/views/termsandconditions/TermsAndConditions";
import PrivacyPolicy from "@/views/termsandconditions/PrivacyPolicy";

// raport sub -----------
import MyRaports from "@/views/raport/my_raports/MyRaports";
import OtherRaports from "@/views/raport/other_raports/OtherRaports";
// raport ThirdRoute
import MakeReport from "@/views/raport/make_report/MakeReport";
import ViewReportDetail from "@/views/raport/view_report_detail/ViewReportDetail";
import ViewMyReport from "@/views/raport/view_my_report/ViewMyReport";
//-----------------------
// pay sub
import PayWithSms from "@/views/pay/pay_with_sms/PayWithSms";
import StreetMap from "@/views/pay/street_map/StreetMap";
// transport sub
import Bicycle from "@/views//transport/bicycle/Bicycle";
import PublicInterUrban from "@/views//transport/public_interurban/PublicInterUrban";
import PublicUrban from "@/views//transport/public_urban/PublicUrban";
import busReport from "@/views//transport/raport_bus_service/raportBus.vue";
//import Taxi from "@/views/transport/taxi/Taxi";
// Trafic sub
import Notification from "@/views/trafic/notification/Notification";
import TraficMap from "@/views/trafic/trafic_map/TraficMap";
import TraficView from "@/views/trafic/trafic_view/TraficView";
// Info sub
import AdministrativeUnit from "@/views/info/adminstrative_unit/AdministrativeUnit";
import Companies from "@/views/info/companies/Companies";
import Education from "@/views/info/education/Education";

// Turisem Children
import TurisemDetail from "@/views/turisem/turisem_detail/TurisemDetail";
import TurisemMap from "@/views/turisem/turisem_map/TurisemMap";

// Plant Children
import ContributePlant from "@/views/plant/contribute_pant/ContributePlant";

// TiranaEYC Children
import TiranaEYCContent from "@/views/tiranaeyc/content/TiranaEYCContent";

// Playground Children
import AllPlayground from "@/views/playground/all_playground/AllPlayground";

// City Events Components
import CityEvents from "@/views/cityevents/CityEvents";
import CityEventsList from "@/views/cityevents/list/CityEventsList";
import CityEventDetails from "@/views/cityevents/details/CityEventDetails";

//NEW MODULES ADDED -->
import Organisation from "@/views/organisation/Organisation";
import Donations from "@/views/donations/donations";
import Volunteering from "@/views/volunteering/volunteering";
import tiranaECS from "@/views/tiranaECS/tiranaECS";

//DORMITORY APPLICATION MODULE
import Dormitory from "@/views/dormitory/dormitory.vue";
import dormitorymodule from "@/views/dormitory/dormitory-module.vue";

// Organisation Sub

import organisationmodule from "@/views/organisation/Organisation-module/organisation-module";
import organisationform from "@/views/organisation/Organisation-details/OrganisationForm.vue";
// import organisationAllForm from "@/views/organisation/organisation-all-form/organisationAllForm.vue";

// Donations Sub
import donationsmodule from "@/views/donations/donations-module/donations-module";
import donationform from "@/views/donations/Donations-details/DonationsForm.vue";

// Volunteering Sub
import volunteeringmodule from "@/views/volunteering/volunteering-module/volunteering-module";
import volunteeringform from "@/views/volunteering/volunteering-details/volunteering-form.vue";
import volunteeringAllForm from "@/views/volunteering/volunteering-all-form/volunteeringAllForm.vue";
import volunteeringApplications from "@/views/volunteering/volunteering-applications/volunteering-applications.vue";

// Tirana ECS Sub
import tiranaECSinfo from "@/views/tiranaECS/tiranaECS-info/tiranaECS-info";

//END OF NEW MODULES

// Air Children
//import Historic from "@/views/air/historical_data/Historic";
//import AirQuality from "@/views/air/air_quality/AirQuality";

/**
 * This is the primary route when the aplication will find the paths of the components
 * where e to navigate
 * it has either an fallback url if some misplaced urls atre triggered
 *
 * Every route is an Object and have the structure of
 * {
 *  path: "", Type String
 *  name: "", Type String
 *  isDashboard: false, Type Boolean
 *  isNavgationBar: true,
 *  component: , Type Vue component
 *  image: require("") Type image path
 * }
 *
 * and childerens of the route are Array of Object
 * that has
 * {
 *   path: Type String
 *   name: Type String
 * },
 *
 */

export default [
	{
		path: "/",
		name: "home",
		isDashboard: false,
		isNavgationBar: false,
		component: Home,
		image: require("@/assets/svg/raporto-icon.svg"),
		meta: { title: "Dashboard" },
	},
	{
		path: "/report",
		name: "report_label",
		component: Raport,
		isDashboard: true,
		isNavgationBar: true,
		redirect: { name: "my_reports_label" },
		props: {
			makeRaport: true,
		},
		meta: { title: "Reports section" },
		children: [
			{
				path: "my-reports",
				name: "my_reports_label",
				image: require("@/assets/svg/raporto-icon.svg"),
				component: MyRaports,
				meta: { title: "My Reports" },
				children: [
					{
						path: "viewmyreport",
						name: "ViewMyReport",
						component: ViewMyReport,
						image: require("@/assets/img/settings.png"),
						props: (route) => ({
							...route.params,
						}),
						meta: { title: "View my reports", isVirtualNav: true },
						children: [
							{
								path: "myreport/:id",
								name: "ViewMyReportDetail",
								image: require("@/assets/img/settings.png"),
								props: (route) => ({
									...route.params,
								}),
								meta: {
									title: "My report details",
									isVirtualNav: true,
								},
								children: [
									{
										path: "photos",
										name: "ViewMyReportPhotos",
										image: require("@/assets/img/settings.png"),
										meta: {
											title: "My report photos",
											isVirtualNav: true,
										},
									},
								],
							},
						],
					},
				],
			},
			{
				path: "other-reports",
				name: "other_reports_label",
				image: require("@/assets/svg/raporto-icon.svg"),
				component: OtherRaports,
				meta: { title: "Others Reports" },
				children: [
					{
						path: "viewreport/:id",
						name: "ViewReportDetail",
						component: ViewReportDetail,
						image: require("@/assets/img/settings.png"),
						props: (route) => ({
							...route.params,
						}),
						meta: {
							title: "Others report details",
							isVirtualNav: true,
						},
						children: [
							{
								path: "photos",
								name: "ViewReportPhotos",
								component: ViewReportDetail,
								image: require("@/assets/img/settings.png"),
								meta: {
									title: "Others report photos",
									isVirtualNav: true,
								},
							},
						],
					},
				],
			},
			{
				path: "makereport",
				name: "MakeReport",
				component: MakeReport,
				image: require("@/assets/img/settings.png"),
				meta: { title: "Make a report", isVirtualNav: true },
				props: {
					makeRaport: false,
				},
			},
			/* {
				path: "viewreport",
				name: "ViewReportDetail",
				component: ViewReportDetail,
				image: require("@/assets/img/settings.png"),
				props: route => ({
					...route.params
				}),
				meta: { isVirtualNav: true }
			} */
		],
		image: require("@/assets/svg/raporto-icon.svg"),
	},
	{
		path: "/pay",
		name: "parking_pay_label",
		isDashboard: true,
		isNavgationBar: true,
		component: PayParking,
		image: require("@/assets/svg/parkim-icon.svg"),
		redirect: { name: "label_payparking_sms" },
		meta: { title: "Parking section" },
		children: [
			{
				path: "with_sms",
				name: "label_payparking_sms",
				image: require("@/assets/svg/parkim-icon.svg"),
				component: PayWithSms,
				meta: { title: "Pay parking with SMS" },
			},
			{
				path: "street_map",
				name: "label_parking",
				image: require("@/assets/svg/parkim-icon.svg"),
				component: StreetMap,
				meta: { title: "Parkings map" },
			},
		],
	},
	{
		path: "/transport",
		isDashboard: true,
		isNavgationBar: true,
		name: "transport",
		component: Transport,
		image: require("@/assets/svg/tranporti-icon.svg"),
		redirect: { name: "bicycle_lanes" },
		meta: { title: "Transport section" },
		children: [
			{
				path: "bycycle",
				name: "bicycle_lanes",
				image: require("@/assets/svg/tranporti-icon.svg"),
				component: Bicycle,
				meta: { title: "Bicycle lanes" },
			},
			{
				path: "urban_transport",
				name: "public_transport",
				image: require("@/assets/svg/tranporti-icon.svg"),
				component: PublicUrban,
				meta: { title: "Public urban" },
			},
			{
				path: "interurban_transport",
				name: "public_transport_interurban",
				image: require("@/assets/svg/tranporti-icon.svg"),
				component: PublicInterUrban,
				meta: { title: "Public Superurban" },
			},
			,
			/* {
				path: "taxi",
				name: "taxi",
				image: require("@/assets/svg/tranporti-icon.svg"),
				component: Taxi
			} */ {
				path: "street_map",
				name: "label_parking_transport",
				image: require("@/assets/svg/tranporti-icon.svg"),
				component: StreetMap,
				meta: { title: "Parkings map" },
			},

			{
				path: "bus_report",
				name: "label_bus_report",
				image: require("@/assets/svg/tranporti-icon.svg"),
				component: busReport,
				meta: { title: "Report Bus Service" },
			},
		],
	},
	{
		path: "/turisem",
		isDashboard: true,
		isNavgationBar: true,
		name: "label_turism",
		component: Turisem,
		redirect: { name: "turisem_map" },
		props: {
			searchTurisem: true,
		},
		meta: { title: "Tourism section" },
		children: [
			{
				path: "turisem_map",
				name: "turisem_map",
				component: TurisemMap,
				image: require("@/assets/svg/turizmi-icon.svg"),
				props: true,
				meta: { title: "Tourism PoI map" },
				children: [
					{
						path: "turisem_search",
						name: "turisem_search",
						component: TurisemMap,
						image: require("@/assets/svg/turizmi-icon.svg"),
						props: true,
						meta: {
							title: "Tourism PoI Search",
							isVirtualNav: true,
						},
					},
				],
			},
			{
				path: "turisemdetail/:point_id",
				name: "TurisemDetail",
				component: TurisemDetail,
				image: require("@/assets/svg/turizmi-icon.svg"),
				props: true,
				meta: { title: "Tourism PoI Details", isVirtualNav: true },
			},
		],
		image: require("@/assets/svg/turizmi-icon.svg"),
	},
	{
		path: "/cityevents",
		isDashboard: true,
		isNavgationBar: true,
		name: "cityevents",
		component: CityEvents,
		image: require("@/assets/svg/events-icon.svg"),
		redirect: { name: "cityevents_list" },
		meta: { title: "City events section" },
		children: [
			{
				path: "cityevents_list",
				name: "cityevents_list",
				component: CityEventsList,
				image: require("@/assets/svg/events-icon.svg"),
				props: true,
				meta: { title: "City events list" },
				children: [
					{
						path: "cityeventdetails/:id",
						name: "cityeventdetails",
						component: CityEventsList,
						image: require("@/assets/svg/events-icon.svg"),
						props: true,
						meta: {
							title: "City event details",
							isVirtualNav: true,
						},
					},
				],
			},
		],
	},
	// {
	// 	path: "/tiranaeyc",
	// 	isDashboard: true,
	// 	isNavgationBar: true,
	// 	name: "tirana_eyc",
	// 	component: TiranaEYC,
	// 	image: require("@/assets/svg/tiranaeyc.png"),
	// 	redirect: { name: "tiranaeyc_content" },
	// 	meta: { title: "Tirana EYC section" },
	// 	children: [
	// 		{
	// 			path: "tiranaeyc_content",
	// 			name: "tiranaeyc_content",
	// 			component: TiranaEYCContent,
	// 			image: require("@/assets/svg/tiranaeyc.png"),
	// 			props: true,
	// 			meta: { title: "Tirana EYC details" },
	// 		},
	// 	],
	// },
	{
		path: "/plant",
		isDashboard: true,
		isNavgationBar: true,
		name: "tree_plant",
		component: Plant,
		image: require("@/assets/svg/mbjell-peme-icon.svg"),
		redirect: { name: "contribute_plant" },
		meta: { title: "Plants section" },
		children: [
			{
				path: "contribute_plant",
				name: "contribute_plant",
				component: ContributePlant,
				image: require("@/assets/svg/mbjell-peme-icon.svg"),
				props: true,
				meta: { title: "Plants details" },
			},
		],
	},
	{
		path: "/playground",
		isDashboard: true,
		isNavgationBar: true,
		name: "playground",
		component: Playground,
		image: require("@/assets/svg/parqe-icon.svg"),
		redirect: { name: "all_playground" },
		meta: { title: "Playgrounds section" },
		children: [
			{
				path: "all_playground",
				name: "all_playground",
				component: AllPlayground,
				image: require("@/assets/svg/parqe-icon.svg"),
				props: true,
				meta: { title: "Playgrounds details" },
			},
		],
	},
	{
		path: "/trafic",
		isDashboard: true,
		isNavgationBar: true,
		name: "traffic_label",
		component: Trafic,
		image: require("@/assets/svg/trafiku-icon.svg"),
		redirect: { name: "rlt_label" },
		meta: { title: "Traffic section" },
		children: [
			{
				path: "map",
				name: "rlt_label",
				image: require("@/assets/svg/trafiku-icon.svg"),
				component: TraficMap,
				meta: { title: "Traffic map" },
			},
			{
				path: "view",
				name: "cctv_label",
				image: require("@/assets/svg/trafiku-icon.svg"),
				component: TraficView,
				meta: { title: "Traffic CCTV" },
				props: true,
				children: [
					{
						path: ":cameraid",
						name: "cctvitemdetails",
						component: TraficView,
						image: require("@/assets/svg/trafiku-icon.svg"),
						props: true,
						meta: {
							title: "Traffic CCTV Details",
							isVirtualNav: true,
						},
					},
				],
			},
			/* {
				path: "notification",
				name: "notifications_streets",
				image: require("@/assets/svg/trafiku-icon.svg"),
				component: Notification
			} */
		],
	},
	// {
	// 	path: "/organisations",
	// 	isDashboard: true,
	// 	isNavgationBar: true,
	// 	name: "organisation_label",
	// 	component: Organisation,
	// 	image: require("@/assets/svg/organisation-icon.svg"),
	// 	redirect: { name: "organisationmodule_label" },
	// 	meta: { title: "Organisations section" },
	// 	children: [
	// 		{
	// 			path: "organisationmodule",
	// 			name: "organisationmodule_label",
	// 			image: require("@/assets/svg/organisation-icon.svg"),
	// 			component: organisationmodule,
	// 			props: true,
	// 			meta: { title: "Organisation module" },
	// 			children: [
	// 				{
	// 					path: "organisationdetails/:id",
	// 					name: "organisationdetails",
	// 					component: organisationmodule,
	// 					image: require("@/assets/svg/organisation-icon.svg"),
	// 					props: true,
	// 					meta: {
	// 						title: "Organisation details",
	// 						isVirtualNav: true,
	// 					},
	// 					children: [
	// 						{
	// 							path: "form",
	// 							name: "organisationform",
	// 							component: organisationform,
	// 							image: require("@/assets/svg/organisation-icon.svg"),
	// 							props: true,
	// 							meta: {
	// 								title: "Organisation form",
	// 								isVirtualNav: true,
	// 							},
	// 						},
	// 					],
	// 				},
	// 			],
	// 		},

	// 		// {
	// 		// 	path: "organisationAllForm",
	// 		// 	name: "organisationAllForm_label",
	// 		// 	image: require("@/assets/svg/organisation-icon.svg"),
	// 		// 	component: organisationAllForm,
	// 		// 	meta: { title: "Form module" },
	// 		// 	children: [],
	// 		// },
	// 	],
	// },
	// {
	// 	path: "/donations",
	// 	isDashboard: true,
	// 	isNavgationBar: true,
	// 	name: "donations_label",
	// 	component: Donations,
	// 	image: require("@/assets/svg/donations-icon.svg"),
	// 	redirect: { name: "donationsmodule_label" },
	// 	meta: { title: "Donations section" },
	// 	children: [
	// 		{
	// 			path: "donationsmodule",
	// 			name: "donationsmodule_label",
	// 			image: require("@/assets/svg/donations-icon.svg"),
	// 			component: donationsmodule,
	// 			meta: { title: "Donations module" },
	// 			children: [
	// 				{
	// 					path: "donationdetails/:id",
	// 					name: "donationdetails",
	// 					component: donationsmodule,
	// 					image: require("@/assets/svg/donations-icon.svg"),
	// 					props: true,
	// 					meta: {
	// 						title: "Donation details",
	// 						isVirtualNav: true,
	// 					},
	// 					children: [
	// 						{
	// 							path: "form",
	// 							name: "donationform",
	// 							component: donationform,
	// 							image: require("@/assets/svg/donations-icon.svg"),
	// 							props: true,
	// 							meta: {
	// 								title: "Donation form",
	// 								isVirtualNav: true,
	// 							},
	// 						},
	// 					],
	// 				},
	// 			],
	// 		},
	// 	],
	// },
	// {
	// 	path: "/volunteering",
	// 	isDashboard: true,
	// 	isNavgationBar: true,
	// 	name: "volunteering_label",
	// 	component: Volunteering,
	// 	image: require("@/assets/svg/volunteering-icon.svg"),
	// 	redirect: { name: "volunteeringmodule_label" },
	// 	meta: { title: "Volunteering section" },
	// 	children: [
	// 		{
	// 			path: "volunteeringmodule",
	// 			name: "volunteeringmodule_label",
	// 			image: require("@/assets/svg/volunteering-icon.svg"),
	// 			component: volunteeringmodule,
	// 			meta: { title: "Volunteering module" },
	// 			children: [
	// 				{
	// 					path: "volunteeringdetails/:id",
	// 					name: "volunteeringdetails",
	// 					component: volunteeringmodule,
	// 					image: require("@/assets/svg/volunteering-icon.svg"),
	// 					props: true,
	// 					meta: {
	// 						title: "Volunteering details",
	// 						isVirtualNav: true,
	// 					},
	// 					children: [
	// 						{
	// 							path: "form",
	// 							name: "volunteeringform",
	// 							component: volunteeringform,
	// 							image: require("@/assets/svg/volunteering-icon.svg"),
	// 							props: true,
	// 							meta: {
	// 								title: "Volunteering form",
	// 								isVirtualNav: true,
	// 							},
	// 						},
	// 					],
	// 				},
	// 			],
	// 		},
	// 		{
	// 			path: "volunteeringAllForm",
	// 			name: "volunteering_topic_form",
	// 			image: require("@/assets/svg/volunteering-icon.svg"),
	// 			component: volunteeringAllForm,
	// 			meta: { title: "Volunteering topic form" },
	// 			children: [],
	// 		},
	// 		{
	// 			path: "volunteeringApplications",
	// 			name: "volunteering_previous_applications_label",
	// 			image: require("@/assets/svg/volunteering-icon.svg"),
	// 			component: volunteeringApplications,
	// 			meta: { title: "Volunteering previous applications module" },
	// 			children: [],
	// 		},
	// 	],
	// },
	// {
	// 	path: "/tiranaECS",
	// 	isDashboard: true,
	// 	isNavgationBar: true,
	// 	name: "tiranaECS_label",
	// 	component: tiranaECS,
	// 	image: require("@/assets/svg/tiranaECS-icon.svg"),
	// 	redirect: { name: "tiranaECSinfo_label" },
	// 	meta: { title: "tiranaECS section" },
	// 	children: [
	// 		{
	// 			path: "tiranaECSinfo",
	// 			name: "tiranaECSinfo_label",
	// 			image: require("@/assets/svg/tiranaECS-icon.svg"),
	// 			props: true,
	// 			component: tiranaECSinfo,
	// 			meta: { title: "TiranaECS info" },
	// 		},
	// 	],
	// },

	{
		path: "/dormitory",
		isDashboard: true,
		isNavgationBar: true,
		name: "dormitory_label",
		component: Dormitory,
		image: require("@/assets/svg/dormitorybooking-icon.svg"),
		redirect: { name: "dormitorymodule_label" },
		meta: { title: "dormitory section" },
		children: [
			{
				path: "dormitorymodule",
				name: "dormitorymodule_label",
				image: require("@/assets/svg/dormitorybooking-icon.svg"),
				props: true,
				component: dormitorymodule,
				meta: { title: "Dormitory module" },
			},
		],
	},

	{
		path: "/info",
		isDashboard: true,
		isNavgationBar: true,
		name: "info_label",
		component: Info,
		image: require("@/assets/svg/info-icon.svg"),
		redirect: { name: "label_info_adm" },
		meta: { title: "Info section" },
		children: [
			{
				path: "andinistative_unit",
				name: "label_info_adm",
				image: require("@/assets/svg/info-icon.svg"),
				component: AdministrativeUnit,
				meta: { title: "Administrative units" },
			},
			{
				path: "companies",
				name: "label_info_enterprise",
				image: require("@/assets/svg/info-icon.svg"),
				component: Companies,
				meta: { title: "Municipality companies" },
			},
			{
				path: "school",
				name: "label_info_education",
				image: require("@/assets/svg/info-icon.svg"),
				component: Education,
				meta: { title: "Education" },
			},
		],
	},
	{
		path: "/setting",
		isDashboard: false,
		isNavgationBar: true,
		name: "settings_label",
		component: Setting,
		image: require("@/assets/svg/settings_icon.svg"),
		meta: { title: "App settings" },
	},
	{
		path: "/termsandconditions",
		isDashboard: false,
		isNavgationBar: true,
		name: "terms_label",
		component: TermsAndConditions,
		image: require("@/assets/svg/terms_conditions_icon.svg"),
		meta: { title: "Terms & Conditions" },
	},
	{
		path: "/privacypolicy",
		isDashboard: false,
		isNavgationBar: true,
		name: "privacy_label",
		component: PrivacyPolicy,
		image: require("@/assets/svg/terms_conditions_icon.svg"),
		meta: { title: "Privacy Policy" },
	},
	{
		path: "*",
		isDashboard: false,
		isNavgationBar: false,
		redirect: "/",
	},
	/* {
		path: "/air",
		isDashboard: true,
		isNavgationBar: true,
		name: "air_label",
		component: Air,
		redirect: { name: 'air_quality_monitoring' },
		children: [
			{
				path: "air_quality",
				name: "air_quality_monitoring",
				component: AirQuality,
				image: require("@/assets/svg/air-quality-icon.svg"),
				props: true
			},
			{
				path: "historic",
				name: "Historic",
				component: Historic,
				image: require("@/assets/img/settings.png")
			}
		],
		image: require("@/assets/svg/air-quality-icon.svg")
	}, */
];
